import APIClient from '@/shared/http/clients/api'

const resourceName = 'etapa'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAllByName = (companyID, name = '', data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/empresa/${companyID}?nome=${name}`, data, config)
const Get = (companyID, code, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/empresa/${companyID}/${code}`, data, config)

const StageRepository = {
  GetAllByName,
  Get
}

export default StageRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/stage.js